import React, { useState } from "react";
import "./styles.scss";
import { IoIosAdd } from "react-icons/io";
import ConfirmationModal from "../../../../../../shared/components/confirmationModal/ConfirmationModal";
import { HiArrowNarrowLeft, MdClose } from "react-icons/all";
import { useAppUser } from "../../../../../../contexts/user-context/UserContext";
import { useHistory, useLocation } from "react-router-dom";
import { BarLoader } from "react-spinners";
import { useWorkShop } from "../../../../../../contexts/workshop-context/WorkshopContext";

const SideBar = () => {
  const workshop = useWorkShop();
  const appUser = useAppUser();
  const { push } = useHistory();

  const [showModel, setShowModel] = useState(false);
  const [showModel2, setShowModel2] = useState(false);
  const [showModelForBack, setShowModelForBack] = useState(false);
  const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false);
  const [selectedSubsection, setSelectedSubsection] = useState(
    workshop.selectedSubSection
  );
  const [needActive, setNeedActive] = useState(workshop.selectedSubSection);
  const editPath: boolean = useLocation().pathname.includes("/edit");

  const [loadingDeletion, setLoadingDeletion] = useState(false);
  const [loadingAdding, setLoadingAdding] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);

  return (
    <div className="new-workshop-side-bar-wrapper">
      <div className="title" style={{ maxWidth: "300px" }}>
        <div className="back-button" style={{ transform: "translateX(6px)" }}>
          <HiArrowNarrowLeft
            onClick={() => {
              if (workshop.selectedSubSection.edited) {
                setShowModelForBack(true);
              } else {
                push("/dashboard/public/library/workshops");
              }
            }}
          />
        </div>
        <div>
          <h4
            className="text-left multi-line-truncate"
            style={{
              maxWidth: "280px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            {workshop.title}
          </h4>
        </div>
      </div>
      <div className="menu">
        <ul className="sub-sections ">
          <li
            className={
              workshop.selectedSubSection.orderNo === -1
                ? "selected-sub-section"
                : ""
            }
            style={{
              fontSize: "1rem",
              textAlign: "center",
              paddingLeft: "0px",
            }}
            onClick={() => {
              workshop.setSelectedSubSection({
                id: "",
                orderNo: -1,
                subSectionTitle: "",
                workshopSectionContent: [],
                mode: "EDIT",
                edited: false,
              });
            }}
          >
            Summary
          </li>
          {workshop.workshopSections.map((section, index) => (
            <li
              key={index}
              className={
                workshop.selectedSubSection.orderNo === section.orderNo
                  ? "subsection-item selected-sub-section"
                  : "subsection-item"
              }
              onClick={() => {
                console.log(
                  workshop.selectedSubSection.orderNo,
                  section.orderNo
                );
                if (workshop.selectedSubSection.edited) {
                  if (workshop.selectedSubSection.orderNo !== section.orderNo) {
                    setShowModel2(true);
                    setNeedActive(section);
                  }
                } else {
                  if (workshop.selectedSubSection.orderNo !== section.orderNo)
                    workshop.setSelectedSubSection(section);
                }
              }}
            >
              <div className="ss-title text-truncate">
                <span className="mr-2">{index + 1}</span>
                {section.subSectionTitle?.trim() !== ""
                  ? section.subSectionTitle
                  : "Sub Section Title"}
              </div>
              {(appUser.userRole.isAdmin || appUser.userRole.isModerator) &&
                editPath && (
                  <div
                    className="ss-close-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedSubsection(section);
                      setShowRemoveConfirmation(true);
                    }}
                  >
                    <MdClose />
                  </div>
                )}
            </li>
          ))}
        </ul>
        {(appUser.userRole.isAdmin || appUser.userRole.isModerator) &&
          editPath && (
            <>
              {loadingAdding ? (
                <div className="px-3">
                  <BarLoader
                    height={4}
                    width={"100%"}
                    color={"#006699"}
                    loading={loadingAdding}
                  />
                </div>
              ) : (
                <div
                  className="add-new-subsection"
                  onClick={() => {
                    if (workshop.selectedSubSection.edited) {
                      setShowModel(true);
                    } else {
                      setLoadingAdding(true);
                      workshop.addSubSection(
                        () => {
                          console.log("loading adding false");
                          setLoadingAdding(false);
                        },
                        () => {
                          setLoadingAdding(false);
                        }
                      );
                    }
                  }}
                >
                  <div className="add-button">
                    <div>
                      <IoIosAdd />
                    </div>
                  </div>
                  <span className="btn-text">Add new subsection</span>
                </div>
              )}
            </>
          )}
      </div>
      <ConfirmationModal
        loading={loadingSave}
        children={{
          headerText: "You have unsaved changes",
          bodyText: (
            <>
              <p>
                If you leave this page, your changes will not be saved. You
                can't undo this action.
              </p>
            </>
          ),
          cancelButtonText: "Discard changes",
          confirmButtonText: "Save changes",
          confirmButtonColor: "blue",
        }}
        show={showModel}
        onCancel={() => {
          workshop.discardChangesAndCreateNewWorkshop();
          setShowModel(false);
        }}
        onConfirm={() => {
          setLoadingSave(true);
          workshop.saveData(
            () => {
              setLoadingSave(false);
              setShowModel(false);
            },
            () => {
              setLoadingSave(false);
              setShowModel(false);
            }
          );
        }}
      />
      <ConfirmationModal
        loading={loadingSave}
        children={{
          headerText: "You have unsaved changes",
          bodyText: (
            <>
              <p>
                If you go back, your changes will not be saved. You can't undo
                this action.
              </p>
            </>
          ),
          cancelButtonText: "Discard changes",
          confirmButtonText: "Save changes",
          confirmButtonColor: "blue",
        }}
        show={showModelForBack}
        onCancel={() => {
          setLoadingSave(false);
          setShowModelForBack(false);

          push("/dashboard/library/workshops");
        }}
        onConfirm={() => {
          setLoadingSave(true);
          workshop.saveData(
            () => {
              setLoadingSave(false);
              setShowModelForBack(false);

              push("/dashboard/library/workshops");
            },
            () => {
              setLoadingSave(false);
              setShowModelForBack(false);
            }
          );
        }}
      />
      <ConfirmationModal
        loading={loadingSave}
        children={{
          headerText: "Confirmation",
          bodyText: (
            <>
              <p>
                Please save the current changes before moving to selected
                section.
              </p>
              <p className="mt-2" style={{ fontSize: "12px" }}>
                You will lose unsaved changes if you continue.
              </p>
            </>
          ),
          cancelButtonText: "Save",
          confirmButtonText: "Continue",
          confirmButtonColor: "red",
        }}
        show={showModel2}
        onCancel={() => {
          setLoadingSave(true);
          workshop.saveDataAndSelectSubSection(needActive.orderNo, () => {
            setLoadingSave(false);
            setShowModel2(false);
          });
        }}
        onConfirm={() => {
          workshop.discardChangesAndSelectSubSection(needActive.orderNo);
          setShowModel2(false);
        }}
      />
      <ConfirmationModal
        loading={loadingDeletion}
        children={{
          headerText: "Delete section",
          bodyText: (
            <>
              <p>
                Are you sure you want to <b>DELETE</b> this section?
              </p>
              <p>You will lose all the content in this section.</p>
            </>
          ),
          cancelButtonText: "Cancel",
          confirmButtonText: "Delete",
          confirmButtonColor: "red",
        }}
        show={showRemoveConfirmation}
        onCancel={() => setShowRemoveConfirmation(false)}
        onConfirm={() => {
          setLoadingDeletion(true);
          workshop.deleteSubSection(
            selectedSubsection,
            () => {
              setLoadingDeletion(false);
              setShowRemoveConfirmation(false);
            },
            () => {
              setLoadingDeletion(false);
              setShowRemoveConfirmation(false);
            }
          );
        }}
      />
    </div>
  );
};

export default SideBar;
